import { ProjectFeature } from '@/types/project-features'
import useGetDetail, { UseGetDetailOptions } from '../core-hooks/useGetDetail'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import buildService from '../create-service'
import queryKeys from '../query-keys'

const service = buildService<ProjectFeature>({
  pathCategory: 'project_features',
})

export function useGetProjectFeature({
  id,
  ...options
}: UseGetDetailOptions<ProjectFeature>) {
  const query = useGetDetail<ProjectFeature>({
    id,
    queryKey: queryKeys.projectFeatures.detail({
      id,
      filters: options.filters,
    }),
    serviceFn: service.getDetail,
    ...options,
  })

  return {
    projectFeature: query.data,
    ...query,
  }
}

export function useGetProjectFeatures({
  filters,
  ...options
}: UseGetListOptions<ProjectFeature> = {}) {
  const query = useGetList<ProjectFeature>({
    filters,
    queryKey: queryKeys.projectFeatures.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    projectFeatures: query.allData,
    ...query,
  }
}
